// extracted by mini-css-extract-plugin
export var addButton = "_9u-0";
export var border = "_9u-8";
export var check = "_9u-h";
export var danger = "_9u-6";
export var dropdownContainer = "_9u-1";
export var editModalBody = "_9u-j";
export var footerContainer = "_9u-i";
export var fullWidth = "_9u-a";
export var hide = "_9u-9";
export var icon = "_9u-3";
export var input = "_9u-7";
export var inputFlex = "_9u-b";
export var inputWrapper = "_9u-c";
export var manualFocus = "_9u-5";
export var optionButton = "_9u-4";
export var pillWrapper = "_9u-e";
export var pointer = "_9u-2";
export var showOverflow = "_9u-f";
export var tagsFlex = "_9u-d";
export var xButton = "_9u-g";